import React, { createContext, useContext, useMemo, useState } from 'react';

const ShuTongContext = createContext({
  currentPoem: null,
  setCurrentPoem: () => {}
});

export function ShuTongProvider({ children }) {
  const [currentPoem, setCurrentPoem] = useState(null);
  const value = useMemo(
    () => ({ currentPoem, setCurrentPoem }),
    [currentPoem]
  );

  return (
    <ShuTongContext.Provider value={value}>
      {children}
    </ShuTongContext.Provider>
  );
}

export function useShuTongContext() {
  return useContext(ShuTongContext);
}
